import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediColors from '../../../../assets/styles/default.scss';


export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        margin: theme.spacing(2, 0),
      },
      box: {
        borderRadius: 4,
        backgroundColor: 'white',
      },
      title: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 'bold',
        fontSize: 12,
        color: sicrediColors.secondarySicrediDarker,
        letterSpacing: 0.25,
        lineHeight: 1.2,
        padding: theme.spacing(1),
        borderBottomWidth: 16,
        borderBottomColor: '#F8F9F7',
      },
      data: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 12,
        color: sicrediColors.secondarySicrediDark,
        letterSpacing: 0.44,
        lineHeight: 1.2,
        padding: theme.spacing(2, 1),
        '& svg': {
          color: sicrediColors.primarySicredi,
          width: 32,
          height: 32,          
        },
      },
      noBreakingData: {
        whiteSpace: 'nowrap',
      },
      navIcon: {
        color: sicrediColors.primarySicrediDark,
        marginLeft: 'auto',
      },
      confirmField: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 300,
        fontSize: 12,
        color: sicrediColors.secondarySicrediDark,
        letterSpacing: 0.44,
        lineHeight: 1.2,        
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0 24px 0 0',
      },
      rightCell :{
        width: '25%',
      },
      middleCell :{
        width: '55%',
      },
      leftCell :{
        width: '10%',
      },
      tipoConta: {
        marginRight: '12px'
      },
      legendas: {
        display: 'flex',
        flexDirection: 'row',
      },
      legendaText: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: '14px',
        fontWeight: 'bold',
        whiteSpace: 'pre-wrap',
        lineHeight: '20px',
        margin: '10px 0',
        marginRight: '20px',
        '&:last-child': {
          marginRight: '0px',
        }
      },
      legendaIcon: {
        fontSize: '16px',
        marginRight: '10px',
        color: sicrediColors.primarySicredi,
        verticalAlign: 'text-bottom',
      },
      tableIcon: {
        width: '16px !important',
        height: '16px !important',
        marginRight: '10px',
        color: sicrediColors.primarySicredi
      },
    }),
  { name: 'RelatorioTabela' }
);
